export default __webpack_public_path__ + "img/313a71932a468b32017bbae966014b98.png";